import { render, staticRenderFns } from "./floor-management2.vue?vue&type=template&id=97fbc2b0&scoped=true"
import script from "./floor-management2.vue?vue&type=script&lang=js"
export * from "./floor-management2.vue?vue&type=script&lang=js"
import style0 from "./floor-management2.vue?vue&type=style&index=0&id=97fbc2b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fbc2b0",
  null
  
)

export default component.exports